import { getImageUrl } from "src/Common/common";

function EditButton({ clicked }) {
  return (
    <div onClick={clicked} className="flex items-center justify-center gap-2 cursor-pointer border-solid border-borderColor border-[1px] rounded-[6px]  h-[30px] w-[70px]">
      <img src={getImageUrl("/images/common/edit.png")} className="w-[14px]" />
      <p className="text-[12px] font-OpenSansMedium font-[600] text-subTitleColor">
        Edit
      </p>
    </div>
  );
}

export default EditButton;
